import React from "react";
import {Button, Card, Col, DatePicker, Icon, Input, Row, Spin, Table, Tag} from 'antd'
import {API, Auth} from "aws-amplify"
import "../../Styles/Services/checkInvoiceCSV.css"
import {connect} from "react-redux";
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors";
import {withRouter} from "react-router-dom";
import moment from "moment";
import {CustomSpinner} from "../../Components/Spin/CustomSpiner";
import BaseDocumentControl from "./BaseDocumentControl";
import locale from "antd/es/date-picker/locale/es_ES";
import EditCandidate from "./EditCandidate"
import CandidateForm from "../../Components/Documents/CandidateForm";

class Candidates extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            candidates: [],
            candidateSelected: {},
            step: 'candidateList',
        }
        this.getCandidates = this.getCandidates.bind(this)
        this.handleStep = this.handleStep.bind(this)
        this.setCandidateList = this.setCandidateList.bind(this)
    }

    getStringFilterProps = (property) => {
        return {
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <div style={{padding: 8}}>
                    <Input
                        ref={node => {
                            this.searchInput = node;
                        }}
                        placeholder="Buscar"
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        icon="search"
                        size="small"
                        style={{width: 90, marginRight: 8}}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters()}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
            ),
            onFilter: (value, record) => (record[property]) ? record[property].toString().toLowerCase().includes(value) : "",
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select())
                }
            }
        }
    }

    getDateFilterProps = (property) => {
        return {
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <div style={{padding: 8}}>
                    <DatePicker
                        placeholder={"Desde"}
                        value={selectedKeys[0] ? selectedKeys[0].from : null}
                        format="DD-MM-YYYY"
                        locale={locale}
                        disabledDate={d => !d || (selectedKeys[0] != null && d.isAfter(selectedKeys[0].to))}
                        onChange={e => setSelectedKeys([{from: e, to: (selectedKeys[0] ? selectedKeys[0].to : null)}])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                        allowClear={true}
                    />
                    <DatePicker
                        placeholder={"Hasta"}
                        disabledDate={d => !d || (selectedKeys[0] != null && d.isBefore(selectedKeys[0].from))}
                        value={selectedKeys[0] ? selectedKeys[0].to : null}
                        format="DD-MM-YYYY"
                        locale={locale}
                        onChange={e => setSelectedKeys([{
                            to: e,
                            from: (selectedKeys[0] ? selectedKeys[0].from : null)
                        }])}
                        onPressEnter={() => confirm()}
                        style={{width: 188, marginBottom: 8, display: 'block'}}
                        allowClear={true}
                    />
                    <Button
                        type="primary"
                        onClick={() => confirm()}
                        icon="search"
                        size="small"
                        style={{width: 90, marginRight: 8}}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters()}
                        size="small"
                        style={{width: 90}}
                    >
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
            ),
            onFilter: (value, record) => {
                const date = moment(record[property], 'YYYY-MM-DD');
                return date.isValid() && date.isAfter(value.from) && date.isBefore(value.to) || date.isSame(value.to) || date.isSame(value.from);
            }
        }
    }

    columns = [
        {
            title: 'Nro. Documento',
            key: 'candidate_number_doc',
            dataIndex: 'candidate_number_doc',
            ...this.getStringFilterProps('candidate_number_doc')
        },
        {
            title: 'Fecha Creación',
            key: 'created',
            dataIndex: 'created',
            render: (value, row, index) => {
                return {
                    children: value ? moment.unix(value).format("DD-MM-YYYY") : ''
                }
            },
            sorter: (a, b) => moment(a.created).diff(b.created),
            defaultSortOrder: 'descend',
            //...this.getDateFilterProps('created')
        },
        {
            title: 'Email',
            key: 'email',
            dataIndex: 'email',
            ...this.getStringFilterProps('email')

        },
        {
            title: 'Nombre',
            key: 'name',
            dataIndex: 'name',
            ...this.getStringFilterProps('name')
        },
        {
            title: 'Apellido',
            key: 'last_name',
            dataIndex: 'last_name',
            ...this.getStringFilterProps('last_name')
        },
        {
            title: 'Tipo Vehículo',
            key: 'vehicle_type',
            dataIndex: 'vehicle_type',
            ...this.getStringFilterProps('vehicle_type')
        },
        {
            title: 'Estado',
            key: 'state_candidate',
            dataIndex: 'state_candidate',
            filters: [
                {
                    text: "COMPLETED",
                    value: "COMPLETED"
                },
                {
                    text: "REJECTED",
                    value: "REJECTED"
                },
                {
                    text: "PENDING",
                    value: "PENDING"
                },
                {
                    text: "APPROVED",
                    value: "APPROVED"
                },
                {
                    text: "PROCESSING",
                    value: "PROCESSING"
                },
                {
                    text: "CREATED",
                    value: "CREATED"
                },
                {
                    text: "VALIDATED",
                    value: "VALIDATED"
                },
                {
                    text: "NOT_VALIDATED",
                    value: "NOT_VALIDATED"
                }
            ],
            filterMultiple: true,
            onFilter: (value, record) => record.state_candidate.indexOf(value) === 0
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record, index) => {
                return {
                    children: <>
                        <Button
                            onClick={() => this.editCandidate(record) }
                            icon="search">
                        </Button>
                    </>
                }
            }
        }
    ]

    editCandidate(candidate) {
        this.setState({candidateSelected: candidate, step: 'candidateEdit'})

    }

    componentDidMount() {
        this.getCandidates()
    }

    getCandidates() {
        Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]).then(([response, user]) => {
            API.get(
                'test',
                '/cd/cdcandidate/',
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
            .then(response => {
                this.setState({loading: false, candidates: response.candidates})
            })
            .catch(err => console.log(err))
        });
    }

    handleStep(stepSelected) {
        this.setState({
            step: stepSelected,
            candidateSelected: null
        })
        this.getCandidates()
    }

    setCandidateList() {
        this.setState({step: 'candidateList'})
        this.getCandidates()
    }

    render() {
        if (this.state.loading) {
            return (
                <BaseDocumentControl selected='candidates'>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseDocumentControl>
            )
        } else if (this.state.step === "candidateList"){
            return (
                <BaseDocumentControl
                    selected='candidates'>
                    <Row>
                        <Card title={'Candidatos'}>
                            <Button type="primary" icon="plus" onClick={()=> {this.setState({step:'candidateCreate'})}}>
                                Crear
                            </Button>
                            <Table
                                columns={this.columns}
                                dataSource={this.state.candidates}
                                scroll={{x: "max-content"}}
                                style={{margin: "20px"}}
                                loading={this.state.loading}
                                pagination={{
                                    showSizeChanger: true,
                                    pageSizeOptions: ['20', '35', '50'],
                                    defaultPageSize: 20,
                                    hideOnSinglePage: true
                                }}
                            />
                        </Card>
                    </Row>
                </BaseDocumentControl>
            )
        } else if (this.state.step === "candidateEdit"){
            return (
                <BaseDocumentControl selected='candidates'>
                    <EditCandidate
                        candidate={this.state.candidateSelected}
                        handleStep={this.handleStep}
                    />
                </BaseDocumentControl>
            )
        } else if (this.state.step === "candidateCreate"){
            return (
                <BaseDocumentControl selected='candidates'>
                    <CandidateForm
                        handleStep={this.handleStep}
                        setCandidateList={this.setCandidateList}
                        operation='CREATE'
                    />
                </BaseDocumentControl>
            )
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Candidates))
